module.exports = __webpack_public_path__ + "static/media/mtnIconSelected.092f6648.svg";